module.exports = __webpack_public_path__ + "static/media/question-divider.8d0d70ef.png";